import styleInject from '../../../node_modules/style-inject/dist/style-inject.es.js';

var css_248z = ".PopupMenu_list__G7xP3{align-items:stretch;border-radius:inherit;display:flex;flex-direction:column;padding:2px}.PopupMenu_item__wxay-:first-child{border-top-left-radius:inherit;border-top-right-radius:inherit}.PopupMenu_item__wxay-:last-child{border-bottom-left-radius:inherit;border-bottom-right-radius:inherit}";
var S = {"list":"PopupMenu_list__G7xP3","item":"PopupMenu_item__wxay-"};
styleInject(css_248z);

export { S as default };
